export const SERVICE_URLS_RECORD_MAP = {
  // SHARED
  CinchcareServiceUrl: 'CINCHCARE_SERVICE_URL',
  PermissionsUrl: 'PERMISSION_URL',
  DeliveryServiceURl: 'DELIVERY_SERVICE_URL',
  OrderServiceUrl: 'ORDER_SERVICE_URL',
  ProfileServiceUrl: 'PROFILE_SERVICE_URL',
  SettlementServiceUrl: 'SETTLEMENT_SERVICE_URL',
  StaticAssetsUrl: 'STATIC_ASSETS_URL',
  IdentityServiceUrl: 'IDENTITY_SERVICE_URL',
  Auth0ServiceUrl: 'AUTH0_SERVICE_URL',
  cinchUrl: 'CINCH_URL',
  cinchAppUrl: 'CINCH_APP_URL',
  consumerValuationsServiceUrl: 'CONSUMER_VALUATIONS_SERVICE_URL',
  CinchChargeCardRequestUrl: 'CINCH_CHARGE_CARD_REQUEST_URL',
  ReservationStatusUrl: 'RESERVATION_STATUS_URL',
  InventoryServiceHistoryUrl: 'INVENTORY_SERVICE_HISTORY_URL',
  IOSAppStoreUrl: 'IOS_APP_STORE_URL',
  AndroidAppStoreUrl: 'ANDROID_APP_STORE_URL',
  UnsubscribeServiceUrl: 'UNSUBSCRIBE_SERVICE_URL',
  ReservationServiceUrl: 'RESERVATION_SERVICE_URL',
  DeliverySlotAvailabilityServiceUrl: 'DELIVERY_SLOT_AVAILABILITY_SERVICE_URL',
  LogisticsAvailabilityServiceUrl: 'LOGISTICS_AVAILABILITY_SERVICE_URL',
  LogisticsFeesServiceUrl: 'LOGISTICS_FEES_SERVICE_URL',
  LogisticsRoutingServiceUrl: 'LOGISTICS_ROUTING_SERVICE_URL',
  LogisticsFulfilmentServiceUrl: 'LOGISTICS_FULFILMENT_SERVICE_URL',
  FinanceApplicationServiceUrl: 'FINANCE_APPLICATION_SERVICE_URL',
  FinanceOfferServiceUrl: 'FINANCE_OFFER_SERVICE_URL',
  FinanceServiceUrl: 'FINANCE_SERVICE_URL',
  FinanceQuoteServiceUrl: 'FINANCE_QUOTE_SERVICE_URL',
  FinanceSoftSearchUrlPath: 'FINANCE_SOFT_SEARCH_URL_PATH',
  PaymentLinkServiceUrl: 'PAYMENT_LINK_SERVICE_URL',
  GapServiceUrl: 'GAP_SERVICE_URL',
  CustomerDataAPIUrl: 'CUSTOMER_DATA_API_URL',
  VehicleOwnershipServiceUrl: 'VEHICLE_OWNERSHIP_SERVICE_URL',
  bankServiceUrl: 'BANK_SERVICE_URL',
  HelpAndSupportUrl: 'HELP_AND_SUPPORT_URL',
  StoreAvailabilityUrl: 'STORE_AVAILABILITY_URL',
  GoogleMapsBaseUrl: 'GOOGLE_MAPS_BASE_URL',
  VehiclePurchaseBaseUrl: 'VEHICLE_PURCHASE_BASE_URL',
  SitesBaseUrl: 'SITES_BASE_URL',
  EvolutionIddUrl: 'EVOLUTION_IDD_URL',
  MarshallPrivacyPolicyUrl: 'MARSHALL_PRIVACY_POLICY_URL',
  SantanderPrivacyPolicyUrl: 'SANTANDER_PRIVACY_POLICY_URL',
  MarshallCommissionStatementUrl: 'MARSHALL_COMMISSION_STATEMENT_URL',
  NewCarsApiUrl: 'NEW_CARS_API_URL',
  FinanceSoftSearchUrlV2: 'FINANCE_SOFT_SEARCH_URL_V2',
  CinchServicingUrl: 'CINCH_SERVICING_URL',
  proposalSubmissionURL: 'PROPOSAL_SUBMISSION_URL',
  IdealPostcodesUrl: 'IDEAL_POSTCODES_URL',
  AwinServiceUrl: 'AWIN_SERVICE_URL',
  VehicleIssueTriageUrl: 'VEHICLE_ISSUE_TRIAGE_URL',

  // ACQUISITION AND CONTENT
  TrustpilotUrl: 'TRUSTPILOT_URL',
  StoryblokBFFComponent: 'STORYBLOK_BFF_COMPONENT',

  // SEARCH
  SearchServiceUrl: 'SEARCH_SERVICE_URL',
  AiSearchServiceUrl: 'AI_SEARCH_SERVICE_URL',

  // PRODUCT DETAIL
  ProductDetailServiceUrl: 'PRODUCT_DETAIL_SERVICE_URL',
  LeadGenServiceUrl: 'LEAD_GEN_SERVICE_URL',
  VapServiceUrl: 'VAP_SERVICE_URL',

  // CONSUMER LENDING
  FeatureFlagServiceUrl: 'FEATURE_FLAG_SERVICE_URL',
} as const

export type ServiceUrls = typeof SERVICE_URLS_RECORD_MAP

export type IServiceUrls = Record<ServiceUrls[keyof ServiceUrls], string>
